module.exports = __webpack_public_path__ + "img/huwelijksdrukwerk-drukwerk-annonce-trouwen-anna-marcelo-goudfolie-foliedruk-italian-wedding-2.8e3af24d.jpg";